module.exports = __webpack_public_path__ + "img/acct_mob_dia.png";